import type { HelpFile } from '../../types/help'
import { BackgroundJobsDashboardTestIds } from '../../../testids/BackgroundJobsDashboardTestIds'

export const backgroundJobsDashboardHelp: HelpFile = {
  docPage: '/docs/jobs/job-scheduler',
  texts: {
    [BackgroundJobsDashboardTestIds.backgroundJobsDashboardPage]:
      'Cluster-weite Übersicht — was läuft, was zuletzt fehlgeschlagen ist und welche Jobs in die Triage gehören.',
    [BackgroundJobsDashboardTestIds.statTotalJobs]:
      'Registrierte Jobs aus allen Quellen (System, Benutzer, Integration).',
    [BackgroundJobsDashboardTestIds.statRunningNow]:
      'Aktuell auf einem Cluster-Knoten laufende Ausführungen.',
    [BackgroundJobsDashboardTestIds.statFailed24h]:
      'Fehlgeschlagene Ausführungen der letzten 24 Stunden.',
    [BackgroundJobsDashboardTestIds.statAvgDuration]:
      'Mittlere Laufzeit der letzten erfolgreichen Ausführungen.',
    [BackgroundJobsDashboardTestIds.cardTitleNeedsAttention]:
      'Jobs mit fehlgeschlagener, überfälliger oder hängender Ausführung — Triage beginnt hier.',
    [BackgroundJobsDashboardTestIds.needsAttention]: null,
    [BackgroundJobsDashboardTestIds.allHealthy]:
      'Kein Job benötigt Aufmerksamkeit — alles läuft planmäßig.',
    [BackgroundJobsDashboardTestIds.cardTitleRecentExecutions]:
      'Jüngste Ausführungen im Cluster, neueste zuerst.',
    [BackgroundJobsDashboardTestIds.recentExecutions]: null,
    [BackgroundJobsDashboardTestIds.cardTitleSourceBreakdown]:
      'Job-Verteilung nach Quelle — System-Aufgaben gegenüber Integrationen und benutzerdefinierten Jobs.',
    [BackgroundJobsDashboardTestIds.sourceBreakdown]: null,
  },
}
